module.exports = __webpack_public_path__ + "static/img/1.6e88f48.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/1.png
// module id = Vx2k
// module chunks = 0